// "Yatak Odanızı Tamamlayın": select items (and their variant), see the total, add them in one request.
// Items with several variants are only added after the customer picks one — nothing is guessed.
if (!customElements.get('oile-look')) {
  customElements.define(
    'oile-look',
    class OileLook extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector('[data-look-add]');
        this.totalEl = this.querySelector('[data-look-total]');
        this.messageEl = this.querySelector('[data-look-message]');
        this.addEventListener('change', () => this.update());
        this.button?.addEventListener('click', () => this.add());
        this.update();
      }

      get rows() {
        return [...this.querySelectorAll('[data-look-item]')].map((row) => {
          const select = row.querySelector('[data-look-select]');
          const variant = row.querySelector('[data-look-variant]');
          const option = variant?.tagName === 'SELECT' ? variant.selectedOptions[0] : variant;
          return {
            selected: Boolean(select?.checked && !select.disabled),
            id: variant?.value || '',
            price: Number(option?.dataset.price || 0),
            variantField: variant?.tagName === 'SELECT' ? variant : null,
          };
        });
      }

      update() {
        const chosen = this.rows.filter((r) => r.selected);
        const total = chosen.reduce((sum, r) => sum + (r.id ? r.price : 0), 0);
        if (this.totalEl) this.totalEl.textContent = total > 0 ? this.formatMoney(total) : '—';
        if (this.button) this.button.disabled = chosen.length === 0;
      }

      async add() {
        const chosen = this.rows.filter((r) => r.selected);
        const missing = chosen.find((r) => !r.id);
        if (missing) {
          this.say(this.dataset.choose, true);
          missing.variantField?.focus();
          return;
        }

        const cart = document.querySelector('cart-drawer');
        const body = { items: chosen.map((r) => ({ id: Number(r.id), quantity: 1 })) };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        this.button.classList.add('loading');
        this.button.setAttribute('aria-disabled', 'true');
        this.button.querySelector('.loading__spinner')?.classList.remove('hidden');
        this.say('');

        try {
          const response = await fetch(`${window.routes.cart_add_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || this.dataset.error);

          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oile-look', cartData: data });
          if (cart) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location = window.routes.cart_url;
          }
          this.say(this.dataset.success);
        } catch (error) {
          this.say(error.message || this.dataset.error, true);
        } finally {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
          this.button.querySelector('.loading__spinner')?.classList.add('hidden');
        }
      }

      say(text, isError = false) {
        if (!this.messageEl) return;
        this.messageEl.textContent = text || '';
        this.messageEl.classList.toggle('oile-look__message--error', isError);
      }

      formatMoney(cents) {
        // Matches snippets/oile-money.liquid: 1.499,90 TL
        if (this.dataset.currency === 'TRY') {
          const [whole, fraction] = (Math.abs(cents) / 100).toFixed(2).split('.');
          return `${cents < 0 ? '-' : ''}${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${fraction} TL`;
        }
        const format = this.dataset.moneyFormat || '{{amount}}';
        const fmt = (value, decimals, thousands, decimal) => {
          const [whole, frac] = (value / 100).toFixed(decimals).split('.');
          return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return fmt(cents, 0, ',', '.');
            case 'amount_with_comma_separator':
              return fmt(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return fmt(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator':
              return fmt(cents, 2, "'", '.');
            default:
              return fmt(cents, 2, ',', '.');
          }
        });
      }
    }
  );
}
